import React, { useState, useEffect } from "react";
import TableValidExcelData from "./tableValidExcelData";
import TableErrExcelData from "./tableErrExcelData";
import InputFile from "./inputFile";
import moment from "moment";
import * as xlsx from "xlsx";
import { ApiSyncUsersFromExcel } from "../../../../api/syncUsersFromExcel";
import toast from "react-hot-toast";
import { FaChartBar, FaCheckCircle, FaFileExcel } from "react-icons/fa";

import ModalDefault from "../../../modalDefault";
import {
  Badge,
  Center,
  Button,
  Group,
  RingProgress,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { ApiCrearCargo, ApiGetAllCargos } from "../../../../api/cargos";

const normalizeHeader = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "")
    .toLowerCase();

const pickValue = (row, aliases) => {
  const normalizedAliases = aliases.map(normalizeHeader);
  const entry = Object.entries(row).find(([key]) =>
    normalizedAliases.includes(normalizeHeader(key))
  );

  return entry ? entry[1] : "";
};

const mapTipoUsuario = (value) => {
  const normalized = normalizeHeader(value);

  if (!normalized) {
    return "";
  }

  if (["si", "s", "siquiero", "cuadrilla"].includes(normalized)) {
    return "cuadrilla";
  }

  if (["no", "n", "trabajador"].includes(normalized)) {
    return "trabajador";
  }

  return value.toString().trim();
};

const BIRTH_DATE_FORMAT = "DD/MM/YYYY";

const parseExcelSerialDate = (value) => {
  const parsed = xlsx.SSF.parse_date_code(value);

  if (!parsed) {
    return null;
  }

  const date = new Date(Date.UTC(parsed.y, parsed.m - 1, parsed.d));
  return Number.isNaN(date.getTime()) ? null : date;
};

const normalizeBirthDate = (value) => {
  if (value === null || value === undefined || value === "") {
    return { value: "", valid: false, reason: "La fecha de nacimiento está vacía" };
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime())
      ? { value: "", valid: false, reason: "La fecha de nacimiento no es válida" }
      : { value: moment(value).format(BIRTH_DATE_FORMAT), valid: true, reason: "" };
  }

  if (typeof value === "number") {
    const parsedDate = parseExcelSerialDate(value);
    return parsedDate
      ? { value: moment(parsedDate).format(BIRTH_DATE_FORMAT), valid: true, reason: "" }
      : { value: "", valid: false, reason: "El número de fecha de Excel no es válido" };
  }

  const rawValue = value.toString().trim();

  if (!rawValue) {
    return { value: "", valid: false, reason: "La fecha de nacimiento está vacía" };
  }

  if (/^\d+(\.\d+)?$/.test(rawValue)) {
    const parsedDate = parseExcelSerialDate(Number(rawValue));
    return parsedDate
      ? { value: moment(parsedDate).format(BIRTH_DATE_FORMAT), valid: true, reason: "" }
      : { value: "", valid: false, reason: "El número de fecha de Excel no es válido" };
  }

  const supportedFormats = [
    "DD/MM/YYYY",
    "D/M/YYYY",
    "DD-MM-YYYY",
    "D-M-YYYY",
    "YYYY-MM-DD",
    "YYYY/MM/DD",
    "MM/DD/YYYY",
    "M/D/YYYY",
    "DD/MM/YY",
    "D/M/YY",
  ];

  const parsedMoment = moment(rawValue, supportedFormats, true);
  if (parsedMoment.isValid()) {
    return {
      value: parsedMoment.format(BIRTH_DATE_FORMAT),
      valid: true,
      reason: "",
    };
  }

  const fallbackDate = moment(new Date(rawValue));
  if (fallbackDate.isValid()) {
    return {
      value: fallbackDate.format(BIRTH_DATE_FORMAT),
      valid: true,
      reason: "",
    };
  }

  return {
    value: "",
    valid: false,
    reason: `Formato de fecha no reconocido: ${rawValue}`,
  };
};

const CargaDeDatosExcelSeguro = () => {
  const [state, setState] = useState([]);
  const [loadsync, setLoadsync] = useState(false);
  const [modal, setModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [report, setReport] = useState([]);
  const [mensaje, setmensaje] = useState(
    "Se ha iniciado sincronizacion de usuarios, espere en el pagina por favor..."
  );
  const [progress, setProgress] = useState({ completed: 0, total: 0 });
  const [cargos, setCargos] = useState([]);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const res = await ApiGetAllCargos();
    if (res.sms === "ok") {
      setCargos(res.data);
    } else {
      toast.error(res.mensaje);
    }
  };

  const downloadTemplate = () => {
    const templateRows = [
      {
        CI: "1309665956",
        Nombres: "MARIA DANIELA",
        Apellidos: "ACOSTA MONTESDEOCA",
        Codigo: "EMP001",
        Cargo: "ASISTENTE DE IMPUESTOS",
        "Fecha nacimiento": "14/08/1992",
        "Tipo usuario": "trabajador",
        Correo: "maria.acosta@empresa.com",
      },
      {
        CI: "0802843508",
        Nombres: "JULEISY MARILIN",
        Apellidos: "ACOSTA QUIJIJE",
        Codigo: "EMP002",
        Cargo: "OBRERO LIMPIEZA",
        "Fecha nacimiento": "27/03/1995",
        "Tipo usuario": "cuadrilla",
        Correo: "juleisy.acosta@empresa.com",
      },
    ];

    const instructionsRows = [
      ["Campo", "Descripción", "Ejemplo", "Requerido"],
      ["CI", "Cédula o identificador del usuario", "1309665956", "Sí"],
      ["Nombres", "Nombres del usuario", "MARIA DANIELA", "Sí"],
      ["Apellidos", "Apellidos del usuario", "ACOSTA MONTESDEOCA", "Sí"],
      ["Codigo", "Código interno del trabajador", "EMP001", "Sí"],
      ["Cargo", "Nombre exacto del cargo", "ASISTENTE DE IMPUESTOS", "Sí"],
      ["Fecha nacimiento", "Se acepta DD/MM/YYYY, YYYY-MM-DD, serial de Excel o fecha de Excel", "14/08/1992", "Sí"],
      ["Tipo usuario", "Escribe trabajador o cuadrilla", "trabajador", "Opcional"],
      ["Correo", "Correo electrónico del usuario", "maria.acosta@empresa.com", "Opcional"],
    ];

    const templateSheet = xlsx.utils.json_to_sheet(templateRows);
    templateSheet["!cols"] = [
      { wch: 16 },
      { wch: 24 },
      { wch: 28 },
      { wch: 16 },
      { wch: 30 },
      { wch: 20 },
      { wch: 18 },
      { wch: 30 },
    ];

    const instructionsSheet = xlsx.utils.aoa_to_sheet(instructionsRows);
    instructionsSheet["!cols"] = [
      { wch: 20 },
      { wch: 45 },
      { wch: 28 },
      { wch: 14 },
    ];

    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, templateSheet, "Plantilla");
    xlsx.utils.book_append_sheet(workbook, instructionsSheet, "Instrucciones");
    xlsx.writeFile(workbook, "plantilla_carga_usuarios.xlsx");
    toast.success("Plantilla descargada correctamente");
  };

  const getFiles = (files) => {
    if (files.length > 0) {
      const reader = new FileReader();
      const selectedFile = files[0];
      reader.readAsArrayBuffer(selectedFile);
      reader.onload = async (e) => {
        const workbook = xlsx.read(e.target.result, { type: "buffer" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
          const json = xlsx.utils.sheet_to_json(worksheet, { defval: "" });

        const dax = await getarray(json);
        setState(dax);
      };

      reader.onerror = (e) => {
        console.log(e);
      };
    }
  };

  const getarray = async (json) => {
    const x = await json.map((data) => {
      return {
        nombres: pickValue(data, ["Nombres", "Nombre", "names"])
          .toString()
          .trim(),
        correo: pickValue(data, ["correo", "Correo", "email", "Email"])
          .toString()
          .trim(),
        apellidos: pickValue(data, ["Apellidos", "Apellido"])
          .toString()
          .trim(),
        ci: pickValue(data, ["CI", "Cedula", "Cédula", "Usuario", "Usuario/Cedula"])
          .toString()
          .trim(),
        cod: pickValue(data, ["Cod", "Codigo", "Código", "Code"])
          .toString()
          .trim(),
        cargo: pickValue(data, ["Cargo", "Puesto"]).toString().trim(),
        ...(() => {
          const birthDate = normalizeBirthDate(
            pickValue(data, [
              "fec_naci",
              "Fecha nacimiento",
              "Fecha Nacimiento",
              "Fecha de nacimiento",
              "Nacimiento",
            ])
          );

          return {
            fech_naci: birthDate.value,
            fech_naci_valida: birthDate.valid,
            fech_naci_error: birthDate.reason,
          };
        })(),
        pre_tipo_usuario_id: mapTipoUsuario(
          pickValue(data, ["cuadrila", "cuadrilla", "Tipo usuario", "Tipo de usuario", "pre_tipo_usuario_id"])
        ),
        fila: data.__rowNum__ + 1,
      };
    });

    


    return x;
  };

  const sincronizar = async () => {
    if (state.length === 0) {
      toast.error("No hay datos para sincronizar");
      return;
    }

    setModal(true);
    setProgress({ completed: 0, total: state.length });
    setLoadsync(true);
    for (let i = 0; i < state.length; i++) {
      const data = state[i];

      if (!data.fech_naci_valida) {
        setReport((old) => [
          ...old,
          {
            ...data,
            sms: "err",
            status: "400",
            mensaje: data.fech_naci_error || "La fecha de nacimiento no es válida",
          },
        ]);

        setProgress((prevProgress) => ({
          ...prevProgress,
          completed: prevProgress.completed + 1,
        }));
        continue;
      }

      const cargo = await getCargo(data);
      let result;
      if (cargo.sms === "err") {
        result = {
          sms: "err",
          status: "404",
          mensaje: cargo.mensaje,
        };
      } else {
        const cod = parseInt(data.cod);

        // Verificar si la conversión de cod a un número entero fue exitosa
        const codValue = isNaN(cod) ? "" : cod.toString();

        // Combinar los datos con el valor de cod actualizado
        const req = {
          ...data,
          ...cargo.data,
          cod: codValue,
        };

        result = await ApiSyncUsersFromExcel(req);
      }

      if (result.sms === "err") {
        setReport((old) => [
          ...old,
          {
            ...data,
            sms: "err",
            status: "500",
            mensaje: result.mensaje,
          },
        ]);
      } else {
        setReport((old) => [
          ...old,
          {
            ...data,
            sms: "ok",
            status: result.status,
            mensaje: result.mensaje,
          },
        ]);
      }
      setProgress((prevProgress) => ({
        ...prevProgress,
        completed: prevProgress.completed + 1,
      }));
    }
    setLoadsync(false);
    setmensaje(
      "Sincronización finalizada, cierra la ventana para ver el reporte"
    );
  };

  const getCargo = async (data) => {
    try {
      const cargo = cargos.find((cargo) => cargo.pre_cargo === data.cargo);
      if (!cargo) {
        const res = await ApiCrearCargo({
          pre_cargo: data.cargo,
          pre_cod_cargo: cargoCode(data.cargo),
        });

        const resuser = await ApiSyncUsersFromExcel({
          ...data,
          cargo: res.cargo.pre_cargo_id,
        });

        if (resuser.sms === "err") {
          return {
            sms: "err",
            mensaje: resuser.mensaje,
            data: null,
          };
        }

        return {
          sms: "err",
          mensaje: `Cargo '${data.cargo}' no encontrado pero creado`,
          data: null,
        };
      }
      return {
        sms: "ok",
        mensaje: "Cargo obtenido correctamente",
        data: {
          cargo: cargo.pre_cargo_id,
        },
      };
    } catch (error) {
      return {
        sms: "err",
        mensaje: error.message,
        data: null,
      };
    }
  };

  function cargoCode(jobTitle) {
    // Convertir el título del trabajo a mayúsculas
    jobTitle = jobTitle.toUpperCase();

    // Dividir el título del trabajo en palabras individuales
    var words = jobTitle.split(" ");

    // Inicializar la abreviatura
    var abbreviation = "";

    // Recorrer cada palabra y agregar la primera letra al resultado
    words.forEach(function (word, index) {
      // Ignorar palabras con menos de tres caracteres
      if (word.length >= 3) {
        abbreviation += word.substr(0, 3); // Tomar los primeros tres caracteres de la palabra
        // Si no es la última palabra válida, agregar un guion bajo
        if (index < words.length - 1) {
          abbreviation += "_";
        }
      }
    });

    return abbreviation;
  }

  const closeActionModal = (data, bandera) => {
    setModal(data);
    setProgress({ completed: 0, total: 0 });
    setReportModal(true);
  };

  const closeActionModalReport = (data, bandera) => {
    setReportModal(data);
    setmensaje(
      "Se ha iniciado sincronizacion de usuarios, espere en el pagina por favor..."
    );
    setReport([]);
    setState([]);
  };

  return (
    <div className="p-2 d-flex flex-column">
      <div>
        <h5>Subir archivo de Excel</h5>
      </div>
      <hr />
      <div className="d-flex flex-wrap gap-2 align-items-center mb-3">
        <Button leftIcon={<FaFileExcel />} onClick={downloadTemplate} color="green">
          Descargar plantilla
        </Button>
        <Text size="sm" color="dimmed">
          Columnas principales: CI, Nombres, Apellidos, Codigo, Cargo, Fecha nacimiento, Tipo usuario y Correo.
        </Text>
      </div>
      <div className="py-3">
        <InputFile
          getFiles={getFiles}
          accept={
            "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        />
      </div>
      <br />
      {state.length > 0 ? (
        <>
          <div className="d-flex justify-content-between align-items-center">
            <h5>Datos válidos</h5>
            <button
              className="bgfondo2 bordecompleto bordesombreado p-3 negrita"
              onClick={sincronizar}
              style={{ background: "green", color: "white" }}
            >
              <i className="fas fa-sync"></i> Sincronizar con el servidor (
              {state.length} registros)
            </button>
          </div>
          <hr />
          <TableValidExcelData data={state} />
        </>
      ) : (
        <div>No hay datos</div>
      )}

      <ModalDefault
        size="lg"
        modal={modal}
        bandera="excel"
        closeAction={closeActionModal}
        titulo="Reporte de sincronización"
        icontitulo={null}
      >
        <Text align="center">{mensaje}</Text>
        <Center>
          <div className="d-flex flex-column">
            {progress.completed !== state.length ? (
              <RingProgress
                sections={[
                  {
                    value: (progress.completed / progress.total) * 100,
                    color: "blue",
                  },
                ]}
                label={
                  <Text color="blue" weight={700} align="center" size="sm">
                    {progress.completed}/{progress.total}
                  </Text>
                }
              />
            ) : (
              <RingProgress
                sections={[{ value: 100, color: "teal" }]}
                label={
                  <Center>
                    <ThemeIcon
                      color="teal"
                      variant="light"
                      radius="xl"
                      size="xl"
                    >
                      <FaCheckCircle size={22} />
                    </ThemeIcon>
                  </Center>
                }
              />
            )}
          </div>
        </Center>
      </ModalDefault>
      <ModalDefault
        size="lg"
        modal={reportModal}
        bandera="excel"
        closeAction={closeActionModalReport}
        titulo="Reporte de sincronización"
        icontitulo={null}
      >
        <Text align="center">Reporte de sincronizacion</Text>
        <Center>
          <RingProgress
            size={150}
            thickness={10}
            roundCaps
            sections={[
              {
                value:
                  (report.filter(
                    (data) => data.sms === "ok" && data.status === "200"
                  ).length /
                    report.length) *
                  100,
                color: "teal",
              },
              {
                value:
                  (report.filter(
                    (data) => data.sms === "ok" && data.status === "201"
                  ).length /
                    report.length) *
                  100,
                color: "orange",
              },
              {
                value:
                  (report.filter((data) => data.sms === "err").length /
                    report.length) *
                  100,
                color: "red",
              },
            ]}
            label={
              <Center>
                <ThemeIcon color="blue" variant="light" radius="xl" size={100}>
                  <FaChartBar size={50} />
                </ThemeIcon>
              </Center>
            }
          />
        </Center>
        <Group position="center">
          <Badge color="teal" variant="filled" radius="xl">
            {
              report.filter(
                (data) => data.sms === "ok" && data.status === "200"
              ).length
            }{" "}
            Registros sincronizados
          </Badge>
          <Badge color="orange" variant="filled" radius="xl">
            {
              report.filter(
                (data) => data.sms === "ok" && data.status === "201"
              ).length
            }{" "}
            Registros creados
          </Badge>
          <Badge color="red" variant="filled" radius="xl">
            {report.filter((data) => data.sms === "err").length} Registros con
            reintentos
          </Badge>
        </Group>
        <div className="mt-3">
          <TableErrExcelData
            data={report.filter(
              (data) =>
                data.sms === "err" ||
                (data.sms === "ok" && data.status === "201")
            )}
          />
        </div>
      </ModalDefault>
    </div>
  );
};

export default CargaDeDatosExcelSeguro;
